import { render } from "./SCR200.vue?vue&type=template&id=2a17caa6"
import script from "./SCR200.vue?vue&type=script&lang=ts"
export * from "./SCR200.vue?vue&type=script&lang=ts"
script.render = render

export default script